import React, { useEffect, useState } from "react";
import { Modal } from "@ts-digital/vrc";
import "./linkedToDeadlines.css";
import { useIntl } from "react-intl";
import numeral from "numeral";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector, useDispatch } from "react-redux";
import { removeMinus } from "../../../libs/utils";
import LoaderSimple from "../../general/loader";
import { FormattedMessage } from "react-intl";
import { notification } from "antd";
import { getReconciliationData } from "../../../store/actions/reconciliation/movements";
import {
  removeReconciliationLink,
  getReconciledSummary
} from "../../../store/actions/reconciliation/operations";
import {delay} from "../../../libs/utils";

const ReconciliationLinkedToDeadlines = props => {
  const {
    onClose,
    openDeadlineDetail,
    movement,
    setVisibleLinkedToDialog,
    visible,
    auth,
    managerUuid,
    itemUuid,
    startDate,
    endDate,
    loadReconciliationMovements
  } = props;

  const dispatch = useDispatch();

  const [removeDeadline, setRemoveDeadline] = useState(false);

  useEffect(() => {
    dispatch(getReconciliationData(movement.id, null));
  }, []);

  const isGettingReconciliationData = useSelector(state => state.reconciliation?.isGettingReconciliatonData);
  const deadlinesReconciled = useSelector(state => state.reconciliation?.listData);

  useEffect(() => {
    dispatch(getReconciliationData( movement.id, null));
  }, [removeDeadline]);

  const openSuccessWithIcon = (
    type, message, description
  ) => {
    notification[type]({
      message: message,
      description: description,
      duration: 8,
      style: { marginTop: "50px" }
    });
  };

  useEffect(() => {
    if (
      !isGettingReconciliationData &&
      deadlinesReconciled.length === 0 &&
      removeDeadline
    ) {
      onClose();
      dispatch(loadReconciliationMovements(
        auth,
        managerUuid,
        itemUuid,
        null,
        startDate,
        endDate
      ));
      openSuccessWithIcon(
        "success",
        "",
        "Il movimento non è più associato a nessuna scadenza."
      );
    }
    if (deadlinesReconciled.length === 0) {
      setRemoveDeadline(true);
    } else {
      setRemoveDeadline(false);
    }
  }, [deadlinesReconciled]);

  const onRemove = deadlineId => {
    dispatch(removeReconciliationLink(
      auth,
      managerUuid,
      itemUuid,
      [{ deadlineId, bankTransactionId: movement.id }],
      "BANK_TRANSACTION"
    )).then(res => delay(3000).then(() => dispatch(getReconciledSummary())));
    setRemoveDeadline(true);
  };

  const renderDeadlines = () => {
    let items = [];
    if (isGettingReconciliationData && !deadlinesReconciled) {
      return (
        <div className="dbx-reconciliation-movements-loading">
          <LoaderSimple />
        </div>
      );
    } 
    deadlinesReconciled.map(element => {
      let sentToAccounting = element.status === "ACCOUNTED";
      let deadline = element.deadline;
      return items.push(<div className="dbx-reconciliation-dialogs-linkedTo-deadline">
        <div className="dbx-reconciliation-dialogs-linkedTo-content-block">
          <div className="dbx-reconciliation-dialogs-linkedTo-deadline-remove-container">
            <div
              style={{ cursor: sentToAccounting ? null : "pointer" }}
              className="dbx-reconciliation-dialogs-linkedTo-deadline-remove"
              onClick={() =>
                sentToAccounting ? {} : onRemove(element.deadlineId)
              }
            >
              <FontAwesomeIcon
                icon={["far", sentToAccounting ? "lock" : "times"]}
              />
            </div>
          </div>
          <div className="dbx-reconciliation-dialogs-linkedTo-deadline-icon">
            <FontAwesomeIcon icon={["far", "link"]} />
          </div>
          <div className="dbx-reconciliation-dialogs-linkedTo-deadline-date">
            {moment(deadline.date).format("DD MMM YYYY")}
          </div>
          <div className="dbx-reconciliation-dialogs-linkedTo-deadline-description">
            {deadline.descriptions + " " + deadline.title}
          </div>
        </div>
        <div
          className="dbx-reconciliation-dialogs-linkedTo-content-block"
          style={{ justifyContent: "flex-end" }}
        >
          <div
            className={
              "dbx-reconciliation-dialogs-linkedTo-deadline-amount" +
                  (deadline.totalAmount < 0 ? " minusAmount" : " plusAmount")
            }
          >
            <FontAwesomeIcon
              icon={[
                "fas",
                deadline.totalAmount < 0 ? "minus-circle" : "plus-circle"
              ]}
            />
            {numeral(removeMinus(deadline.totalAmount)).format("0,0.00")}
            {" €"}
          </div>
          <div
            className={
              "dbx-reconciliation-dialogs-linkedTo-deadline-payment"
            }
          >
            <FontAwesomeIcon
              icon={["fas", "user"]}
              style={{
                color:
                      ["paid", "collected"].indexOf(deadline.paymentStatus) > -1
                        ? "rgb(9, 130, 42)"
                        : deadline.paymentStatus === "unpaid"
                          ? "var(--status-alert)"
                          : "rgb(253, 185, 39)"
              }}
            />
            <FormattedMessage id={"deadlines." + deadline.paymentStatus} />
          </div>
          <div
            className="dbx-reconciliation-dialogs-linkedTo-deadline-goTo"
            onClick={() => {
              setVisibleLinkedToDialog(false);
              openDeadlineDetail(element.deadlineId);
            }}
          >
            <FontAwesomeIcon icon={["far", "eye"]} />
          </div>
        </div>
      </div>);
    });
    
    return items;
  };

  return (
    <Modal
      onClose={onClose}
      visible={visible ? true : false}
      title={useIntl().formatMessage({
        id: "reconciliation.movements.dialogs.linkedTo.title"
      })}
    >
      <div className="dbx-reconciliation-dialogs-linkedTo-root">
        <div className="dbx-reconciliation-dialogs-linkedTo-tip">
          {useIntl().formatMessage({ id: "reconciliation.movements.dialogs.linkedTo.tip" },
            {
              amount: (
                <strong>
                  {numeral(movement.amount < 0 ? -1 * movement.amount : movement.amount).format("0,0.00") + " €"}
                </strong>
              ),
              date: (
                <strong>
                  {moment(movement.transactionDate).format("DD MMM YYYY")}
                </strong>
              ),
              description: <strong>{movement.description}</strong>
            })}
        </div>
        <div className="dbx-reconciliation-dialogs-linkedTo-deadlines">
          {!isGettingReconciliationData ? renderDeadlines() : <LoaderSimple />}
        </div>
      </div>
    </Modal>
  );
};

export default ReconciliationLinkedToDeadlines;
